import StepTitle from "./StepTitle";
import {useState} from "react";
import styled from 'styled-components';
import StepWizard from 'react-step-wizard';
import { useTheme } from '@mui/material/styles';

const StylesTitleSteps = styled.div`
    display: flex;
    align-items: flex-start;
    padding: 12px 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 768px) {
        padding: 16px 12px;
    }
    @media (min-width: 992px) {
        padding: 8px 0;
    }

    .step{
        &:first-child{
            .box-step{
                padding-left:15px;
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
            }
        }
        &:last-child{
            .box-step{
                padding-right:15px;
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
            }
        }
    }
`

function Wizard({
    options,
    children,
}){
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [stepIndex, setStepIndex] = useState(1);
    const [wizardInstance, setWizardInstance] = useState();
    const [currentOptions, setCurrentOptions] = useState(options.map(opt=>({...opt,validate:false})));

    const onStepChange = ({activeStep,previousStep}) => {
        if(previousStep<activeStep){
            currentOptions[previousStep-1].validate = true;
            currentOptions[activeStep-1].validate = true;
        }
        setCurrentOptions([...currentOptions]);
        setStepIndex(activeStep);
    }

    const onClickStep = (index) => {
        /* const currentIndex = index - 1;
        if((currentIndex-1)>0 && !currentOptions[currentIndex-1].validate){
            return;
        }
        wizardInstance.goToStep(index); */
    }


    return(
    <>
        <StylesTitleSteps className="mb-2 mb-lg-3">
            {
                currentOptions.map((opt,key)=>{
                    const currentIndex = key + 1;
                    return (
                        <StepTitle
                            {...opt}
                            className="step"
                            selected={stepIndex === currentIndex}
                            key={key}
                            index={currentIndex}
                            isLast={key === currentOptions.length - 1}
                            onClick={() => onClickStep(currentIndex)}
                        />
                    );
                })
            }
        </StylesTitleSteps>
        <div className="row">
            <div className="col-12">
                <StepWizard
                    instance={setWizardInstance}
                    isHashEnabled
                    onStepChange={onStepChange}
                    initialStep={stepIndex}
                >
                    {children}
                </StepWizard>
            </div>
        </div>
    </>
    );
}

Wizard.defaultProps = {
    options:[],
};

export default Wizard;